// src/helper/formatAMPM.js

// 12-hour format me time dikhane ke liye (e.g. "2:30 PM")
export const formatAMPM = (date) => {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  return `${hours}:${minutes} ${ampm}`;
};

// night time string ko Date object me convert karta hai
// (24:00:00 ka matlab agle din 00:00:00 hota hai, isliye special handling)
export const parseNightTime = (dateStr, timeStr) => {
  if (timeStr === "24:00:00") {
    const d = new Date(`${dateStr}T00:00:00`);
    d.setDate(d.getDate() + 1);
    return d;
  }
  return new Date(`${dateStr}T${timeStr}`);
};

// '11:19 PM' jaise 12-hour string ko '23:19:00' (24-hour) me convert karta hai
export const convertTo24Hour = (timeStr12) => {
  const [time, modifier] = timeStr12.split(" ");
  let [hours, minutes] = time.split(":").map(Number);
  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:00`;
};

// serviceStart se serviceEnd ke beech, night window (startNightTime -> endingNightTime)
// ke saath total kitne hours overlap hote hain (multi-day bookings ke liye bhi kaam karta hai)
export const getNightHoursOverlap = (
  serviceStart,
  serviceEnd,
  startNightTime,
  endingNightTime
) => {
  let totalNightMs = 0;

  const cursor = new Date(serviceStart);
  cursor.setHours(0, 0, 0, 0);
  cursor.setDate(cursor.getDate() - 1); // ek din pehle se start

  const rangeEnd = new Date(serviceEnd);
  rangeEnd.setHours(0, 0, 0, 0);
  rangeEnd.setDate(rangeEnd.getDate() + 1); // ek din baad tak

  while (cursor <= rangeEnd) {
    const dateStr = cursor.toISOString().split("T")[0];

    const nightStart = parseNightTime(dateStr, startNightTime);
    let nightEnd = parseNightTime(dateStr, endingNightTime);

    // agar endingNightTime, startNightTime se pehle padta hai -> window agle din tak jaata hai
    if (nightEnd <= nightStart) {
      nightEnd = new Date(nightEnd.getTime() + 24 * 60 * 60 * 1000);
    }

    const overlapStart = new Date(
      Math.max(serviceStart.getTime(), nightStart.getTime())
    );
    const overlapEnd = new Date(
      Math.min(serviceEnd.getTime(), nightEnd.getTime())
    );

    if (overlapEnd > overlapStart) {
      totalNightMs += overlapEnd.getTime() - overlapStart.getTime();
    }

    cursor.setDate(cursor.getDate() + 1);
  }

  return totalNightMs / (1000 * 60 * 60); // total hours return
};